<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <v-app>
      <div class="row" v-if="checkoutToken">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="row mb-3">
                  <div class="col-lg-12">
                    <v-expansion-panels flat popout hover>
                      <v-expansion-panel>
                        <v-expansion-panel-header class="bg-light">
                          <span
                            ><v-icon left>mdi-magnify</v-icon>Detaylı
                            Arama</span
                          >
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div class="container-xxl-fluid">
                            <div class="row">
                              <div class="col-lg-3">
                                <search-select
                                  :search-type="'current'"
                                  @itemChange="(e) => (selectedCurrent = e)"
                                  :label="'Cari'"
                                >
                                </search-select>
                              </div>
                              <div class="col-lg-3">
                                <v-select
                                  v-model="salesPersonCode"
                                  label="Plasiyer"
                                  filled
                                  solo
                                  dense
                                  clearable
                                  :items="salesPersonList"
                                  :item-text="(item) => item.name"
                                  :item-value="(item) => item.code"
                                >
                                </v-select>
                              </div>
                              <div class="col-lg-3">
                                <v-select
                                  v-model="branchcode"
                                  label="Şube Kodu"
                                  filled
                                  solo
                                  dense
                                  :items="branchList"
                                  item-value="code"
                                  item-text="name"
                                >
                                </v-select>
                              </div>

                              <div class="col-lg-3">
                                <v-select
                                  v-model="isErp"
                                  label="Durum"
                                  filled
                                  solo
                                  dense
                                  :items="[
                                    { value: 2, text: 'Onaylanmadı' },
                                    { value: 1, text: 'Onaylandı' },
                                  ]"
                                  item-value="value"
                                  item-text="text"
                                >
                                </v-select>
                              </div>

                              <div class="col-lg-3">
                                <v-select
                                  v-model="type"
                                  label="Tip"
                                  filled
                                  solo
                                  dense
                                  :items="[
                                    { value: 2, text: 'Kredi Kartı' },
                                    { value: 1, text: 'Nakit' },
                                  ]"
                                  item-value="value"
                                  item-text="text"
                                >
                                </v-select>
                              </div>

                              <div class="col-lg-3">
                                <v-menu
                                  transition="scale-transition"
                                  offset-y
                                  :close-on-content-click="false"
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      :value="formattedDate(startDate)"
                                      label="Tarih Aralık Başlangıç"
                                      prepend-inner-icon="mdi-calendar"
                                      readonly
                                      filled
                                      solo
                                      dense
                                      clearable
                                      @click:clear="startDate = null"
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="startDate"
                                    locale="tr"
                                  ></v-date-picker>
                                </v-menu>
                              </div>
                              <div class="col-lg-3">
                                <v-menu
                                  transition="scale-transition"
                                  offset-y
                                  :close-on-content-click="false"
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      :value="formattedDate(endDate)"
                                      label="Tarih Aralık Bitiş"
                                      prepend-inner-icon="mdi-calendar"
                                      readonly
                                      filled
                                      solo
                                      dense
                                      clearable
                                      @click:clear="endDate = null"
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="endDate"
                                    locale="tr"
                                  ></v-date-picker>
                                </v-menu>
                              </div>
                              <div class="col-lg-12 text-end">
                                <v-btn
                                  color="primary darken-1"
                                  small
                                  @click="_fetchAllPayments"
                                >
                                  <v-icon left>mdi-magnify</v-icon>
                                  Filtrele
                                </v-btn>
                              </div>
                            </div>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="col-lg-12 d-flex flex-wrap">
                <div>
                  <p class="text-center">Gösterilen Kayıt Sayısı</p>
                  <v-btn-toggle mandatory solo dense>
                    <v-btn @click="perPage = 10"> 10</v-btn>
                    <v-btn @click="perPage = 20"> 20</v-btn>
                    <v-btn @click="perPage = 30"> 30</v-btn>
                    <v-btn @click="perPage = 50"> 50</v-btn>
                  </v-btn-toggle>
                </div>
                <div class="ms-auto">
                  <v-btn small color="success darken-1" @click="makePayment"
                    >Ödeme Yap
                  </v-btn>
                </div>
              </div>
              <div class="m-3">
                <b-table
                  head-row-variant="info"
                  table-variant="white"
                  :items="paymentList"
                  :fields="paymentListHeaders"
                  hover
                  responsive
                  :per-page="perPage"
                  :busy="paymentListLoading"
                  style="font-size: 12px"
                  show-empty
                >
                  <template #table-busy>
                    <div class="text-center">
                      <b-spinner
                        variant="primary"
                        size="lg"
                        label="Text Centered"
                      ></b-spinner>
                    </div>
                  </template>
                  <template #empty="scope">
                    <h6 class="text-center my-5">
                      {{
                        scope.loading
                          ? "Lütfen Bekleyin"
                          : noDataMessage
                          ? noDataMessage
                          : "Veri Bulunamadı"
                      }}
                    </h6>
                  </template>
                  <template #cell(totalAmount)="data">
                    <span>{{
                      numberConverter(data.item.totalAmount) + " ₺"
                    }}</span>
                  </template>
                  <template #cell(erpCustomerCode)="data">
                    <div class="d-flex flex-column">
                      <span class="fs-6 fw-bold">{{
                        data.item.erpCustomerName
                      }}</span>
                      <span class="fs-7 fw-normal">{{
                        data.item.erpCustomerCode
                      }}</span>
                    </div>
                  </template>
                  <template #cell(bank)="data">
                    {{ data.item.bank.name }}
                  </template>
                  <template #cell(paidDate)="data">
                    {{ formattedDate(data.item.paidDate, "DD-MM-YYYY") }}
                  </template>
                  <template #cell(status)="data">
                    <v-tooltip v-if="data.item.status === 30" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          @click="copyValue(2,data.item.bankErrorMessage)"
                          v-bind="attrs"
                          v-on="on"
                          label
                          small
                          outlined
                          :color="findColor(data.item.status)"
                        >
                          {{ findStatus(data.item.status) }}
                        </v-chip>
                      </template>
                      <span>{{ data.item.bankErrorMessage }}</span>
                    </v-tooltip>
                    <div v-else>
                      <v-chip
                        label
                        small
                        outlined
                        :color="findColor(data.item.status)"
                      >
                        {{ findStatus(data.item.status) }}
                      </v-chip>
                    </div>
                  </template>
                  <template #cell(orderNumber)="data">
                    <div class="text-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            class="mb-1"
                            style="color: black"
                            small
                            @click="copyValue(1,data.item.orderNumber)"
                            >mdi-information-outline</v-icon
                          >
                        </template>
                        <span>{{ data.item.orderNumber }}</span>
                      </v-tooltip>
                    </div>
                  </template>
                  <template #cell(installment)="data">
                    <span>{{
                      data.item.installment === 0 || data.item.installment === 1
                        ? "Tek Çekim"
                        : data.item.installment
                    }}</span>
                  </template>
                  <template #cell(process)="data">
                    <div>
                      <v-menu :v-model="showActionsMenu" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mx-1"
                            small
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            @click="showActionsMenu = data.item.orderNumber"
                          >
                            İşlemler
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                            @click="openReciptDialog(data.item.orderNumber)"
                          >
                            <v-list-item-icon>
                              <v-icon color="indigo darken-2"
                                >mdi-note-text-outline</v-icon
                              >
                            </v-list-item-icon>
                            <v-list-item-title>Makbuz</v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            v-if="
                              user.RoleGroupId === 1 || user.RoleGroupId === '1'
                            "
                            v-show="!data.item.isErp"
                          >
                            <v-list-item-icon>
                              <v-icon color="indigo darken-2">mdi-check</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Erp Aktar</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <VirtualPosReceiptDialog
            :showDialog="showReceiptDialog"
            @dialogChange="(e) => (showReceiptDialog = e)"
            :receipt-value="receiptValue"
          ></VirtualPosReceiptDialog>
        </div>
      </div>
      <div v-else class="mt-10">
        <div
          v-if="!checkoutLoginLoading"
          class="d-flex flex-column justify-content-center align-items-center"
        >
          <span class="fs-4 fw-medium" style="color: red">
            {{ "Sanal Pos Modülünüz Aktif Değildir." }}
          </span>
        </div>
        <div
          v-else
          class="d-flex flex-column justify-content-center align-items-center"
        >
          <b-spinner
            variant="primary"
            size="xl"
            label="Text Centered"
          ></b-spinner>
          <span class="fs-4 fw-medium">
            {{ "Yükleniyor" }}
          </span>
        </div>
      </div>
    </v-app>
  </Layout>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { formattedDate } from "@/momentHelper";
import { numberConverter } from "../../../helpers";
import SearchSelect from "@/components/searchSelect.vue";
import Layout from "@/pages/layout/main";
import PageHeader from "@/components/page-header";
import { swalToast } from "@/helpers/swalToast";
import VirtualPosReceiptDialog from "./VirtualPosReceiptDialog.vue";

export default {
  name: "PaymentList",
  page: {
    title: "Ödeme Listesi",
    meta: [{ name: "payment", content: "ÖdemeListesi" }],
  },
  components: { SearchSelect, Layout, PageHeader, VirtualPosReceiptDialog },
  computed: {
    ...mapState("company", ["branchList"]),
    ...mapState("auth", ["user"]),
    ...mapState("current", ["salesPersonList"]),
    ...mapState("virtualPayment", [
      "checkoutLoginLoading",
      "checkoutToken",
      "noDataMessage",
      "paymentList",
      "paymentListHeaders",
      "paymentListLoading",
    ]),
  },
  mounted() {
    this._fetchAllPayments();
    this.getBranchList();
  },
  data() {
    return {
      checkoutLoadiong: false,
      title: "Ödeme Listesi",
      items: [
        {
          text: "Ödeme Listesi",
          active: true,
        },
      ],
      perPage: 10,
      currentPage: 1,
      startDate: null,
      endDate: null,
      type: null,
      isErp: null,
      categoryValue: null,
      selectedCurrent: null,
      currentSearchText: null,
      searchCurrentLoading: false,
      currentSearchResult: [],
      searchCurrentTimeout: null,
      branchcode: null,
      showNewPhyCollectionDialog: false,
      showReceiptDialog: false,
      salesPersonCode: null,
      showActionsMenu: false,
      processType: "new",
      collectionIdValue: null,
      receiptValue: null,
    };
  },
  methods: {
    numberConverter,
    ...mapActions("current", ["fetchCurrentList"]),
    ...mapActions("company", ["fetchBranchList"]),
    ...mapActions("virtualPayment", [
      "fetchPaymentList",
      "checkoutLogin",
      "receiptGenerate",
    ]),
    ...mapMutations("company", ["setBranchList"]),
    ...mapActions("collactions", ["collectionDelete", "collectionApprove"]),

    formattedDate,
    closeMenu() {
      this.showActionsMenu = false;
    },
    async copyValue(type,value) {
      await navigator.clipboard.writeText(value);
      await swalToast.fire({
        title: "",
        text: type === 1 ? "Sipariş No Kopyalandı" : "Ödeme Hatası Kopyalandı",
        icon: "success",
        iconColor: "green",
      });
    },
    findColor(status) {
      switch (status) {
        case 10:
          return "secondary";
        case 20:
          return "success";
        case 30:
          return "error";
        default:
          return "Bilinmiyor";
      }
    },
    findStatus(status) {
      switch (status) {
        case 10:
          return "Beklemede";
        case 20:
          return "Ödendi";
        case 30:
          return "Hatalı";
        default:
          return "Bilinmiyor";
      }
    },
    async _fetchAllPayments() {
      this.checkoutLoadiong = true;
      await this.checkoutLogin();
      this.checkoutLoadiong = false;
      await this.fetchPaymentList({
        params: {
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          erpCustomerCode:
            this.user.RoleGroupId === "3" ? this.user.ErpCode : undefined,
          erpSalesPersonCode:
            this.user.RoleGroupId === "2"
              ? this.user.SalesPersonCode
              : undefined,
        },
        body: {
          StartDate: this.startDate,
          EndDate: this.endDate,
          Type: this.type,
          IsErp: this.isErp,
          CurrentCode: this.selectedCurrent,
          SalesPersonCode: this.salesPersonCode,
          BranchCode: this.branchcode,
        },
      });
    },
    async openReciptDialog(item) {
      this.receiptValue = await this.receiptGenerate(item);
      this.showReceiptDialog = true;
    },
    async makePayment() {
      this.$router.push({ name: "virtualPayment" });
    },
    async getBranchList() {
      await this.fetchBranchList({
        params: {},
        body: {},
      });
      let tempBranchList = this.branchList.slice();
      tempBranchList.unshift({ code: -1, name: "Tüm Şubeler" });
      this.setBranchList(tempBranchList);
    },
    async searchCurrentList() {
      this.currentSearchResult = await this.fetchCurrentList({
        params: {
          userId: this.user.UserId,
          pageNumber: 1,
          pageSize: 50,
          ...((this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2
            ? true
            : false) && { salesPersonCode: this.user.SalesPersonCode }),
          ...((this.currentSearchText == "" || this.currentSearchText == null
            ? false
            : true) && { searchText: this.currentSearchText }),
        },
        body: {},
        onlyData: true,
        loading: false,
      });
      this.searchCurrentLoading = false;
    },
  },
  watch: {
    currentSearchText: function (newVal) {
      if (newVal && newVal.length > 2) {
        if (this.searchCurrentTimeout) clearTimeout(this.searchCurrentTimeout);
        this.searchCurrentLoading = true;
        this.currentSearchResult = [];
        this.searchCurrentTimeout = setTimeout(() => {
          this.searchCurrentList();
        }, 3000);
      } else {
        this.searchCurrentLoading = false;
        if (this.searchCurrentTimeout) clearTimeout(this.searchCurrentTimeout);
      }
    },
  },
};
</script>

<style scoped></style>
